import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { useDispatch, useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar, faUserCog } from '@fortawesome/free-solid-svg-icons'

import { getUsers } from '../../../actions/adminActions'

import { AdminHeader } from '../Index'
import { AdminTd, AdminTh, AdminTable } from '../Tables'
import Button from '../../utils/Button'

const AdminUsersIndex = () => {
  const dispatch = useDispatch()
  const users = useSelector(store => store.admin.users)

  const email = React.createRef()

  useEffect(() => {
    dispatch(getUsers())
  }, [])

  return (
    <div>
      <AdminHeader>Users</AdminHeader>

      <div className="flex space-x-3 mb-4">
        <input type="text" ref={email} className="text-2xl border border-gray-400 rounded-md p-1" />
        <Button color="green" onClick={() => dispatch(getUsers(email?.current?.value))}>
          Search
        </Button>
      </div>

      <AdminTable>
        <thead>
          <tr>
            <AdminTh>Id</AdminTh>
            <AdminTh>Email</AdminTh>
            <AdminTh><FontAwesomeIcon icon={faStar} className="text-green-500 text-xl" /></AdminTh>
            <AdminTh>Active</AdminTh>
            <AdminTh></AdminTh>
          </tr>
        </thead>
        <tbody>
          {users.map((obj, index) => (
            <tr key={index} className={clsx(obj.id && index % 2 !== 0 && 'bg-green-100')}>
              <AdminTd>{obj.id || <Skeleton width="5ch" />}</AdminTd>
              <AdminTd>{(obj.id && obj.email) || <Skeleton width="25ch" />}</AdminTd>
              <AdminTd>{obj.premium && <FontAwesomeIcon icon={faStar} className="text-green-500 text-xl" />}</AdminTd>
              <AdminTd>{obj.availabilityRequestsActiveCount}</AdminTd>
              <AdminTd>
                <Link to={`/admin/users/${obj.id}`}>
                  <FontAwesomeIcon icon={faUserCog} className="text-green-500 text-xl" />
                </Link>
              </AdminTd>
            </tr>
          ))}
        </tbody>
      </AdminTable>
    </div>
  )
}

export default AdminUsersIndex
